<template>
	<AppIcon name="cards-field-image-preview" :width="30" :height="30" v-if="showImagePreview" />
	<v-img v-else max-width="30" @error="showImagePreview = true" :src="src" :width="30" />
</template>
<script>
export default {
	name: 'CardRowImage',
	props: {
		src: { type: String },
		isTemplateMode: { type: Boolean },
	},
	data() {
		return {
			showImagePreview: this.isTemplateMode,
		};
	},
};
</script>
<style scoped lang="scss">
.img-preview {
	border-radius: 5px;
}
</style>
